<template>
  <div>
    <Register />
  </div>
</template>

<script setup>
import Register from './layout/Register.vue'
import { onBeforeMount, onMounted } from 'vue'
import { dataAfastamento } from './store'
import { storeApp } from '@/store'

const store = dataAfastamento
const appStore = storeApp.state

onBeforeMount(() => {
  store.commit('reset')
})

onMounted(async () => {
  appStore.loading = true
  
  appStore.loading = false
})

</script>
